import Glass from "./Glass";


export default function TopPanel({config, dimensions}) {
    return (
        <div className="topPanel">
            <div className="topPanel__content">
                <Glass config={{color: config.color}} dimensions={dimensions}/>
            </div>
            <div className="topPanel__footer"/>
        </div>
    )
}


